$(document).ready(function () {
  $(`.title-phone-button`).click(function () {
    $(`.pop-up-block`).fadeIn(300);
    $(`.call-back-form`).fadeIn(300);
    $(`html`).css(`overflow-y`, `hidden`);
  });

  $(`.request-price`).click(function () {
    $(`.pop-up-block`).fadeIn(300);
    $(`.request-price-form`).fadeIn(300);
    $(`html`).css(`overflow-y`, `hidden`);
  });

  $(`.layout`).click(function () {
    $(`.pop-up-block`).fadeIn(300);
    $(`.layout-form`).fadeIn(300);
    $(`html`).css(`overflow-y`, `hidden`);
  });

  $(`.any-questions`).click(function () {
    $(`.pop-up-block`).fadeIn(300);
    $(`.questions-form`).fadeIn(300);
    $(`html`).css(`overflow-y`, `hidden`);
  });

  $(`.footer-callback-button`).click(function () {
    $(`.pop-up-block`).fadeIn(300);
    $(`.footer-callback-form`).fadeIn(300);
    $(`html`).css(`overflow-y`, `hidden`);
  });

  $(`.x-icon`).click(function () {
    $(`.pop-up-block`).fadeOut(300);
    $(`.pop-up-form-wrapper`).fadeOut(300);
    $(`html`).css(`overflow-y`, `visible`);
  });

  $(`.pop-up-close-overlay`).click(function () {
    $(`.pop-up-block`).fadeOut(300);
    $(`.pop-up-form-wrapper`).fadeOut(300);
    $(`html`).css(`overflow-y`, `visible`);
  });
});
